import hljs from 'highlight.js/lib/core';
import php from 'highlight.js/lib/languages/php';
import twig from 'highlight.js/lib/languages/twig';

window.hljs = hljs;
require('highlightjs-line-numbers.js');

hljs.registerLanguage('php', php);
hljs.registerLanguage('twig', twig);

$("a.trace-box").click(function() {
    let li = $(this).parent();
    let id = li.data('id');

    $("a.trace-box").parent().removeClass('active');
    li.addClass('active');

    $(".trace-data").removeClass('active');
    $(`.trace-data[data-id="${id}"]`).addClass('active');
})

hljs.highlightAll()

$('.trace-data code').each(function(el,block) {
    let startFrom = $(this).closest('.trace-data').data('start_from');
    let line = $(this).closest('.trace-data').data('line');

    hljs.lineNumbersBlock(block, {
        startFrom
    });

    let code = $(this);
    let interval = setInterval(function() {
        if(code.find('table').length > 0) {
            clearInterval(interval);
            code.find(`[data-line-number="${line}"]`).css('background', 'rgba(0,0,0,0.1)')
        }
    }, 100);
});

$('#trace li.expand').click(function() {
    let index = $(this).data('index');
    if(!$(this).data('expand')) {
        $(this).text('Hide frames..')
        $(this).data('expand', true);

        $(this).closest('.trace-stack').find('li.child').show();
    } else {
        $(this).text(`Show ${$(this).data('count')} frames..`)
        $(this).data('expand', false);

        $(this).closest('.trace-stack').find('li.child').hide();
    }
})


